import React, { useEffect } from "react";
import Header from "../../../components/User/Header/Header";
import Footer from "../../../components/User/Footer/Footer";

function ExcessBaggageDelivery() {

   useEffect(()=>{
  window.scrollTo(0,0)
    },[])

  return (
    <div className="page-wrapper">
      <Header/>
      {/* Hero Section  */}
      <section
        class="call-to-action-one sp-four"
        //   style={{ backgroundImage: `url(${HomeBanner})` }}
      >
        <div class="container">
          <div class="sec-title-one white text-center">
            <h2>Insight on Excess Baggage delivery and procedures</h2>
          </div>
        </div>
      </section>
      <section className="why-chooseus sp-four">
        <div className="container">
          <div className="row">
            <div className="col-xl-6 col-md-12 col-sm-12">
              <div className="choose-left-content">
                <div className="sec-title-one mt-0">
                  {/* <h5>Our Qualification</h5> */}
                  <h2>
                    <span>The Pleasure of care free </span>
                    <br />
                    and hassle free travelling.
                  </h2>
                </div>
                <div className="text text-justify mt-45">
                  <p>
                    Baggage weighing more than the limit allowed on an aircraft
                    and liable to an extra charge is “excess baggage”. This
                    excess baggage is referred to as unaccompanied baggage
                    because it requires payment of additional freight and is
                    sent separately as cargo. The best way to avoid inconvenience and stress is to send
                    your baggage ahead with Carrymybaggage. Shipping your excess
                    baggage with Carrymybaggage is the easiest, fastest and
                    affordable way to send your baggage to your desired
                    destination. We believe that a journey is a wonderful
                    experience and should be enjoyed so make your journey worth
                    by sending your baggage with Carrymybaggage.{" "}
                  </p>
                </div>
              </div>
            </div>
            <div className="col-xl-6 col-md-12 col-sm-12">
              <div className="choose-right-area">
                <figure>
                  <img
                    src={require("../../../images/resource/shoose-us-1.jpg")}
                    alt=""
                  />
                </figure>
              </div>
            </div>
          </div>
        </div>
        <div className="container excess-baggage-container-main mobile-view-hide">
          <div className="row">
            <div className="col-xl-6 col-md-12 col-sm-12">
              <div className="choose-right-area">
                <figure>
                  <img
                    src={require("../../../images/resource/shoose-us-1.jpg")}
                    alt=""
                  />
                </figure>
              </div>
            </div>
            <div className="col-xl-6 col-md-12 col-sm-12">
              <div className="choose-left-content">
                <div className="sec-title-one">
                  {/* <h5>Our Qualification</h5> */}
                  <h2>
                    <span>How we ship </span>
                    <br />
                    your baggage
                  </h2>
                </div>
                <div className="text-justify mt-45">
                  <p>
                  Anywhere in the world with ease and affordability. Whether your baggage is in grams or tons, our team handles everything with extensive care. From delicate, valuable items to heavy equipment, we ensure safe and timely delivery to your desired destination. With reliable services and competitive pricing, we simplify logistics, making shipping hassle-free. Trust us to provide exceptional customer support and seamless solutions, regardless of the size or complexity of your shipment. Wherever you need us, we're ready to assist.{" "}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="container excess-baggage-container-main mobile-view-show">
          <div className="row">
            <div className="col-xl-6 col-md-12 col-sm-12">
              <div className="choose-left-content">
                <div className="sec-title-one">
                  {/* <h5>Our Qualification</h5> */}
                  <h2>
                    <span>How we ship </span>
                    <br />
                    your baggage
                  </h2>
                </div>
                <div className="text-justify mt-45">
                  <p>
                  Anywhere in the world with ease and affordability. Whether your baggage is in grams or tons, our team handles everything with extensive care. From delicate, valuable items to heavy equipment, we ensure safe and timely delivery to your desired destination. With reliable services and competitive pricing, we simplify logistics, making shipping hassle-free. Trust us to provide exceptional customer support and seamless solutions, regardless of the size or complexity of your shipment. Wherever you need us, we're ready to assist.{" "}
                  </p>
                </div>
              </div>
            </div>
            <div className="col-xl-6 col-md-12 col-sm-12">
              <div className="choose-right-area">
                <figure>
                  <img
                    src={require("../../../images/resource/shoose-us-1.jpg")}
                    alt=""
                  />
                </figure>
              </div>
            </div>
          </div>
        </div>
        <div className="container excess-baggage-container-main">
          <div className="row">
            <div className="col-xl-6 col-md-12 col-sm-12">
              <div className="choose-left-content">
                <div className="sec-title-one">
                  {/* <h5>Our Qualification</h5> */}
                  <h2>
                    <span>Excess baggage shipping -</span>
                    <br />
                    from tip to toe
                  </h2>
                </div>
                <div className="text-justify mt-45">
                  <p>
                    When you book your excess baggage shipment with
                    Carrymybaggage, our online system begins to manage your
                    shipment. You are then instructed to pack your belongings
                    and packaging material is made available on demand (we
                    provide cartons, bubble wrap, parcel tape etc.). A
                    collection date of your baggage is decided over phone call
                    mail and your baggage is collected from your doorstep
                    accordingly. We take extra care while handling your baggage
                    to ensure safe and undamaged arrival of your baggage at the
                    destination. Once your bags are on the way, our online
                    tracking system update you about it every step of the way.
                    {" "}
                  </p>
                </div>
              </div>
            </div>
            <div className="col-xl-6 col-md-12 col-sm-12">
              <div className="choose-right-area">
                <figure>
                  <img
                    src={require("../../../images/resource/shoose-us-1.jpg")}
                    alt=""
                  />
                </figure>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-xl-12 col-md-12 col-sm-12">
              <div className="choose-left-content">
                <div className="text-justify">
                  <p>
                    Our procedure of sending baggage is 100% reliable,
                    trustworthy and economical. Our 24X7 customer support system
                    ensures that customer’s concerns and queries are well
                    answered and resolved in time.
                    Our team carries out all the documentation formality very
                    professionally. On confirmation of the delivery of your
                    baggage we notify you that your baggage is awaiting your
                    arrival at the destination.  We transform a procedure into an experience and leave
                    memories for you to cherish. Trust Carrymybaggage for sending your excess baggage. The
                    ultimate solution for all excess baggage shipping needs.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
}

export default ExcessBaggageDelivery;
